import React from 'react';
import environmentModel from './model/projectGroupsModel';
import { SelectBasePrototype } from 'clad';

const SelectEnvironment = React.forwardRef((props, ref) => {
    const { data, value, onChange, mode, placeholder, labelInValue } = props;

    const handleFetch = ({ query, id, pagination }) =>
        environmentModel.list({ query, id, pagination });

    return (
        <SelectBasePrototype
            mode={mode}
            placeholder={placeholder}
            schema={{ idOption: 'mid', option: 'name' }}
            fetch={handleFetch}
            onChange={onChange}
            value={value}
            data={data}
            labelInValue={labelInValue || false}
        />
    );
});

export default SelectEnvironment;
